



















































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../../shared/services/mixin";
import {Component, Prop} from "vue-property-decorator";
import {LadingStore} from "@/modules/ladings/store";

@Component({
    name: "InfoDeliveryReceiveLading"
})
export default class extends mixins(CommonMixin){
    @Prop() readonly ladingRowGuid!: string;
    inputSize = 'small';

    get lading() {
        return LadingStore.data[this.ladingRowGuid];
    }

    get getAcceptanceEmployee() {
        let result = "";
        if (this.getProp(this.lading, 'ladingAccepted')) {
            result = this.getProp(this.lading, 'acceptanceEmployee.fullname') || this.getProp(this.lading, 'acceptancePartner.name');
        }
        return result;
    }

    get getAcceptancePostOffice() {
        return this.getProp(this.lading, 'acceptancePostOffice.name');
    }

    get getDeliveryPostOffice() {
        let result = "";
        if (this.getProp(this.lading, 'ladingDeliveried')) {
            result = this.getProp(this.lading, 'deliveryPostOffice.name');
        }
        return result;
    }

    get getDeliveryEmployee() {
        let result = "";
        if (this.getProp(this.lading, 'ladingDeliveried')) {
            result = this.getProp(this.lading, 'deliveryEmployee.fullname') || this.getProp(this.lading, 'deliveryPartner.name');
        }
        return result;
    }
}
